import dayjs from "../../../utils/dayjs";
import { Alert, Form } from "antd";
import React from "react";

export const CheckNumeroInterprete = ({}) => {
  // if (dataForm?.[keys[0]] === undefined || dataForm?.[keys[1]] === undefined) {
  //   return <></>;
  // }

  const abacusId = Form.useWatch("interpreteData.abacusId");

  return null;
};
